import type { ReactNode } from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { lookupLabel } from './expressionLabel';

const LOOKUP = /\{\{@((?:\$[A-Za-z]+(?:>[A-Za-z]+)*|[^{}>$])+?)((?:>[^{}]*)?)\}\}/g;

/**
 * A stored expression, read-only. Reference lookups become chips so a table of
 * defaults reads as intent rather than as syntax; everything else stays literal.
 */
export function ExpressionText({ value, tokenName }: { value: string; tokenName: string }) {
  if (!value) return null;

  const parts: ReactNode[] = [];
  let cursor = 0;

  for (const match of value.matchAll(LOOKUP)) {
    const start = match.index ?? 0;
    if (start > cursor) parts.push(value.slice(cursor, start));

    parts.push(
      <span
        key={start}
        title={match[0]}
        className="inline-flex items-center gap-1 rounded bg-accent px-1.5 py-0.5 font-mono text-xs text-accent-foreground ring-1 ring-border"
      >
        <BookOpenIcon className="size-3.5" aria-hidden="true" />
        {lookupLabel(match[1], tokenName)}
        {match[2]}
      </span>
    );

    cursor = start + match[0].length;
  }

  if (parts.length === 0) return <>{value}</>;

  parts.push(value.slice(cursor));
  return <>{parts}</>;
}
